export const TRANSFER_METHODS = {
  LOCAL: {
    title: "Borderless Instant",
    duration: "0-1 Business Days",
    charges: "5 USD",
    recommended: true,
  },
  SWIFT: {
    title: "SWIFT",
    duration: "1-3 Business Days",
    charges: "15 USD",
    recommended: false,
  },
};

export const BENEFICIARY_STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  MANUAL_REVIEW: "MANUAL_REVIEW",
};

export const SUPPORT_EMAIL = "help@borderless.world";

export const BENEFICIARY_ADDED_MESSAGE =
  "For added security, we check every new beneficiary before you can send money to it. Our team will call you on your registered phone number to confirm you added it. Want it done sooner? Email our support team.";

export const TAG_INFO = {
  LOCAL:
    "Local transfer: sent through the local payment network, usually faster and cheaper.",
  SWIFT:
    "SWIFT transfer: sent through the international banking network, typically takes 1-3 business days.",
  MANUAL_REVIEW: `Under review for your security. We'll call your registered number to confirm. Need it sooner? Email ${SUPPORT_EMAIL}.`,
};

// Method tag colours: approved = green, under review = grey
export const METHOD_TAG_APPROVED_CLASS =
  "bg-[#E6F4EA] text-[#2E7D32] border border-[#B7DFC0] hover:bg-[#D9EEDF]";

export const CURRENCY_OPTIONS = [
  "All",
  'Debit Card',
  "GBP",
  "USD",
  "CAD",
  "SGD",
  "AUD",
  "EUR",
];

export const STATUS_MESSAGES = {
  PAID: "Successful",
  PROCESSING: "Processing",
  REJECTED: "Failed",
  SENT: "Processing",
  PENDING: "Initiated",
  FAILED: "Failed",
  FUNDED: "Fund Received",
  FULLY_CLEARED: "Successful",
  PARTIALLY_CLEARED: "Successful",
  PARTIALLY_REVERSED: "Successful",
  FULLY_REVERSED: "Successful",
  COMPLETED:"Successful"
  
};

export const INITIAL_FORM_DATA = {
  entity_type: "",
  first_name: "",
  last_name: "",
  country_code: "",
  postcode: "",
  state: "",
  city: "",
  street_address: "",
  account_number: "",
  swift_code: "",
  account_routing_type1: "",
  account_routing_value1: "",
  transfer_method: "",
};

export const INITIAL_ERRORS = {
  entity_type: "",
  first_name: "",
  last_name: "",
  country_code: "",
  postcode: "",
  state: "",
  city: "",
  street_address: "",
};
export const CONVERSION_INPUT_TYPES = {
  FROM: "FROM",
  TO: "TO",
  NONE: null,
};

export const TRANSACTION_TYPE = "CONVERSION";
export const TRANSFER_METHOD = "LOCAL";
export const TRANSFER_OTP_REASON = "transaction_initiated";
export const CONVERSION_OTP_REASON = "conversion_initiated";
export const OTP_LENGTH = 6;
export const OTP_LOCKOUT_CLOSE_MS = 3000;
